import { RATING_SURVEY_WITH_TEXT_TYPES } from "./constants";

export const isRatingQuestionWithText = (type: string) => {
  return RATING_SURVEY_WITH_TEXT_TYPES.some(
    (questionType) => questionType.toString() === type
  );
};
